import { CubagesVariantsApiRemoteService } from '../../Services/api/cubages-variants/cubages-variants-service'
import { ICubageVariantEntity } from '../../Services/api/cubages-variants/cubages-variants.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowCubagesVariationsUseCase
implements IFormUsecase<string, ICubageVariantEntity> {
  constructor (private readonly CubagesVariationsApi: CubagesVariantsApiRemoteService) {}
    

  public async handle (
    variantId: string
  ): Promise<Result<ICubageVariantEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CubagesVariationsApi.show(variantId)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
